import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { validarManifiestoActivo } from '../../pages/OnRoad/utils/validarManifiesto';
import Swal from 'sweetalert2';

const OnRoadProtectedLayout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Verificar si es una salida manual
        const esSalidaManual = sessionStorage.getItem('salida_manual');
        if (esSalidaManual) {
            sessionStorage.removeItem('salida_manual');
            return;
        }
        
        const token = localStorage.getItem('tokenOperacion');
        const tenantEmpresa = localStorage.getItem('tenantEmpresa');
        if (!token) {
            Swal.fire({
                icon: 'warning',
                title: 'Acceso restringido',
                text: 'Debe validar sus datos para acceder.',
                allowOutsideClick:false,
            }).then(() => navigate(`/onroad/${tenantEmpresa || ''}`));
            return;
        }

        (async () => {
            const activo = await validarManifiestoActivo();
            if (!activo) {
                localStorage.clear();
                Swal.fire({
                    icon: 'warning',
                    title: 'Manifiesto inactivo',
                    text: 'Por favor ingrese de nuevo.',
                    showConfirmButton:false,
                    timer: 3000,
                    timerProgressBar: true,
                    allowOutsideClick:false,
                }).then(() => navigate(`/onroad/${tenantEmpresa || ''}`));
            }
        })();
    }, [navigate]);

    return <Outlet />;
};

export default OnRoadProtectedLayout;